// Tipos para el plano de sitio (V_LotesSVG)

export type ProyectoCode = "VN" | "VI" | "VB" | "VC";

export interface ProyectoConfig {
  code: ProyectoCode;
  nombre: string;
  /** viewBox del SVG: "minX minY width height" */
  viewBox: string;
  /** URL pública de la imagen base del sitio (svg o SVG del fondo). */
  bgImage: string;
  /**
   * Si es true, el plano usa este `viewBox` tal cual (extensión completa del
   * SVG) en vez de auto-ajustarse al bounding box de los lotes. Útil cuando los
   * lotes no cubren todo el conjunto (calles, áreas verdes, parcelas grandes)
   * y se quiere ver el plano completo como en el SVG original.
   */
  useStaticViewBox?: boolean;
}

/** Una fila de la vista V_LotesSVG. Mapea 1:1 con las columnas reales. */
export interface LoteSVG {
  idLote: number;
  lote: string;
  proyecto: ProyectoCode;
  estado: string;
  idEstado: number;
  colorHex: string;
  /** Color del chip del banco (#RRGGBB). Puede venir null si no hay banco. */
  colorHEXBan: string | null;
  area: number;
  frente: number;
  fondo: number;
  /** atributo `d` del path SVG */
  dPath: string;
  idModDefecto: number | null;

  // Datos del caso (si el lote está reservado/vendido)
  cliente: string | null;
  modeloCaso: string | null;
  modeloTramitado: string | null;
  modeloConstruido: string | null;
  actividadC: string | null;
  vendedor: string | null;
  niveles: string | null;
  banco: string | null;

  precioVenta: number | null;
  precioCasa: number | null;
  precioLote: number | null;

  /** ISO yyyy-MM-dd o null */
  fechaReserva: string | null;
  fechaPF: string | null;
  fechaEntrega: string | null;

/** Links a PDFs (catastro / croquis tramitado / croquis construido) */
  linkCatastro: string | null;
  azureCroquisTramitado: string | null;
  azureCroquisConstruido: string | null;

  /** Datos adicionales para la vista de tabla */
  formalizador: string | null;
  fechaFormalizacion: string | null;
  diasContrato: number | null;
    /** Flags */
  tgEnConstruccion: boolean | null;
  tgConPermiso: boolean | null;
}

export interface SitePlanFilters {
  estado: string | null;
  modelo: string | null;
  vendedor: string | null;
  search: string;
}

export const EMPTY_FILTERS: SitePlanFilters = {
  estado: null,
  modelo: null,
  vendedor: null,
  search: "",
};

/**
 * viewBox tomados del SelectSVG actual en Power Apps.
 * Si la imagen base cambia, ajustar aquí — coordenadas en mismo sistema que d_Path.
 */
export const PROYECTOS: Record<ProyectoCode, ProyectoConfig> = {
  VN: {
    code: "VN",
    nombre: "Valle Novarum",
    viewBox: "33 -277 1367 1321",
    bgImage: "/site-plans/valle-novarum.svg",
  },
  VI: {
    code: "VI",
    nombre: "Valle Ilios",
    viewBox: "1395 -380 1000 2180",
    bgImage: "/site-plans/valle-ilios.svg",
  },
  VB: {
    code: "VB",
    nombre: "Valle Barani",
    viewBox: "555 -3 250 770",
    bgImage: "/site-plans/valle-barani.svg",
  },
  // viewBox tomado del SVG generado por pdf_to_siteplan_svg.py. De todos modos
  // SitePlan recalcula el viewBox dinamicamente desde el bbox real de los lotes
  // (contentViewBox), asi que este valor solo aplica como fallback mientras
  // cargan los lotes.
  VC: {
    code: "VC",
    nombre: "Valle Castilla",
    viewBox: "0 0 3872.13 2177.01",
    bgImage: "/site-plans/valle-castilla.svg",
    // Los lotes VC no cubren todo el conjunto (calles, verdes, parcela
    // grande a la derecha), asi que mostramos el viewBox completo del SVG en
    // vez de auto-ajustar al bbox de los lotes (que recortaba el plano).
    useStaticViewBox: true,
  },
};
